import React from 'react'
import { Box } from "@mui/material";
import RatesChart from "./RatesChart";

export default function InterestRates() {
  return (
    <Box>
      <RatesChart yearValue={15} />
    </Box>
  )
}
